module.exports = __webpack_public_path__ + "img/juventus-logo-icon.581056db.png";